<media-manager [media]="exchange?.media" (updateMedia)="onUpdatedMedia($event)"></media-manager>
<app-timeline *ngIf="exchange" [context]="'exchange'" [contextId]="exchange.id"></app-timeline>
